import React, { useState } from "react";
import { Card, CardBody, Row, Col, Button } from "reactstrap";
import NotificationModal from "../Modal/NotificationModal";
import { postNotificationRead } from "../../actions/notificationActions";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";

export default function SingleNotification({ notification }) {
  const [notificationModalIsOpen, setNotificationModalIsOpen] = useState(false);
  const dispatch = useDispatch();
  const toggleNotificationModal = () => {
    setNotificationModalIsOpen(!notificationModalIsOpen);
  };

  const handleMarkAsRead = (notificationId, read) => {
    dispatch(postNotificationRead(notificationId, read));
  };

  return (
    <>
      <Card>
        <CardBody style={{ padding: ".5rem" }}>
          <Row>
            <Col className="my-auto">
              <span
                onClick={() => {
                  toggleNotificationModal();
                }}
                className={
                  notification.isSeenByMe
                    ? "notification-title--read lead"
                    : "notification-title--unread lead"
                }
              >
                {notification.notice.title}
              </span>
            </Col>
            <Col lg="3" className="my-auto">
              {notification.notice.showFrom}
            </Col>
            <Col lg="3">
              {!notification.isSeenByMe && (
                <Button
                  outline
                  color="primary"
                  className="pull-right m-1"
                  onClick={() => handleMarkAsRead(notification.notice.id, true)}
                >
                  <FormattedMessage id="MarkAsRead" />
                </Button>
              )}
              <Button
                outline
                color="primary"
                className="pull-right m-1"
                onClick={() => {
                  toggleNotificationModal();
                }}
              >
                <FormattedMessage id="Show" />
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <NotificationModal
        notification={notification}
        isOpen={notificationModalIsOpen}
        toggle={toggleNotificationModal}
        handleMarkAsRead={handleMarkAsRead}
      />
    </>
  );
}
